import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface AgentV2SaveTemplateResponse {
  message: string;
  agent_id: string;
  user_id: number;
  is_agent: number;
}

export interface AgentV2SaveTemplateRequest {
  styleId: string;
  actorModelId?: string;
  voiceModelId?: string;
  agentId: string;
  userId: string;
  templateName: string;
  coverUrl: string; // 风格封面
  coverVideo?: string; // 风格视频
  type: number;
  speedRatio?: number;
  scene?: string;
  templateId?: string;
}

export class AgentV2SaveTemplateData {
  id?: number;
}

const transformAndValidateData = (
  response: AgentV2SaveTemplateResponse
): AgentV2SaveTemplateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2SaveTemplateData);
  } catch (error) {
    console.error("AgentV2SaveTemplate data validation failed:", error.message);
    throw error;
  }
};

// 保存智能体模板
export const agentV2SaveTemplate = async (data: AgentV2SaveTemplateRequest[]) => {
  const res = await api.post<AgentV2SaveTemplateResponse>('/agent-v2/save-template', {
    save_info: data.map(item => {
      return {
        style_id: item.styleId,
        actor_model_id: item.actorModelId,
        voice_model_id: item.voiceModelId,
        agent_id: item.agentId,
        user_id: item.userId,
        template_name: item.templateName,
        cover_url: item.coverUrl,
        cover_video: item.coverVideo,
        type: item.type,
        speed_ratio: item.speedRatio,
        scene: item.scene,
        template_id: item.templateId,
      }
    })
  });
  return transformAndValidateData(res.data);
};
